import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/export-project/start', 'post'>;
type ResponseBody = OASOutput<O, '/api/export-project/start', 'post'>;

type Params = {
  quizGuid?: string | undefined;
  mandatoryItemIds?: number[] | undefined;
  projectId: number;
  exportType: 'Scorm12' | 'Scorm2004' | 'TinCan' | 'OfflineiOS' | 'PackageWithInMemoryTrackingClient' | 'DispatchScorm';
};

type Result = {
  packageId: string;
  sasToken: string;
};

export const exportProjectFactory = (apiClient: ApiClient) => {
  const exportProject = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/export-project/start'].post(requestBody);
    if (response.status !== 200) {
      throw new Error('Error exporting project');
    }

    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
        exportType: input.exportType,
        quizGuid: input.quizGuid ?? null,
        mandatoryItemIds: input.mandatoryItemIds ?? null,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      packageId: response.packageId,
      sasToken: response.sasToken,
    };
  };

  return exportProject;
};
